export default "required = Required\ninvalid-workshop-link = Invalid Steam Workshop link.\ninvalid-youtube-link = Invalid YouTube link.\n"